// extracted by mini-css-extract-plugin
module.exports = {"selectionCategory":"styles_selectionCategory__1tP18","eventCard":"styles_eventCard__2_1sj","typeEvent":"styles_typeEvent__1d0Bm","webinar":"styles_webinar__13Wfd"};